import Constants from 'expo-constants';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { BaseReporter, TrackingProperties } from './base-reporter';

const JITSU_CONFIG = Constants.expoConfig?.extra?.jitsu;
const SEGMENT_CONFIG = Constants.expoConfig?.extra?.segment;

const FLUSH_COUNT = 20;
const FLUSH_TIMEOUT = 5000;

export class AnalyticsReporter extends BaseReporter {
  static _loaded = false;

  static identify = (userUUID: string, properties: TrackingProperties) => {
    window.analytics?.identify(userUUID, properties);
  };

  static initialize = () => {
    if (typeof window.analytics !== 'undefined') {
      return;
    }

    // Jitsu's own web client doesn't support batching, so we always use
    // Segment's web client (it can talk to Jitsu and supports batching).
    window.analytics = new AnalyticsBrowser();
  };

  static load = () => {
    if (
      AnalyticsReporter._loaded ||
      !(window.analytics instanceof AnalyticsBrowser)
    ) {
      return;
    }

    if (JITSU_CONFIG) {
      const cdnURL = `https://${JITSU_CONFIG.host}`;
      const apiHost = `${JITSU_CONFIG.host}/v1`;

      window.analytics?.load(
        {
          cdnURL,
          writeKey: JITSU_CONFIG.writeKey,
        },
        {
          integrations: {
            'Segment.io': {
              apiHost,
              deliveryStrategy: {
                config: {
                  size: FLUSH_COUNT,
                  timeout: FLUSH_TIMEOUT,
                },
                strategy: 'batching',
              },
            },
          },
          updateCDNSettings: (settings) => ({
            ...settings,
            metrics: {
              ...settings.metrics,
              sampleRate: 0,
            },
          }),
        },
      );
    } else {
      window.analytics?.load(
        {
          cdnURL: 'https://sgmt-cdn.usepepper.com',
          writeKey: SEGMENT_CONFIG.writeKey,
        },
        {
          integrations: {
            'Segment.io': { apiHost: 'sgmt-api.usepepper.com/v1' },
          },
        },
      );
    }

    AnalyticsReporter._loaded = true;
  };

  static reset = () => {
    window.analytics?.reset();
  };

  static screen = (to: string, properties: TrackingProperties) => {
    window.analytics?.page(to, properties);
  };

  static track = (name: string, properties: TrackingProperties) => {
    window.analytics?.track(name, properties);
  };
}
